/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Kb7Inputs */

const en_mk_cmp_clickup_kb7 = /** @type {(inputs: Mk_Cmp_Clickup_Kb7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still thin.`)
};

const id_mk_cmp_clickup_kb7 = /** @type {(inputs: Mk_Cmp_Clickup_Kb7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masih sedikit.`)
};

/**
* | output |
* | --- |
* | "Still thin." |
*
* @param {Mk_Cmp_Clickup_Kb7Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_kb7 = /** @type {((inputs?: Mk_Cmp_Clickup_Kb7Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Kb7Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_kb7(inputs)
	return en_mk_cmp_clickup_kb7(inputs)
});